import {
  OFFICIAL_REPORT,
  REPORT_TYPES,
  COVER_AND_REPORT_LAYOUT,
  REPORT_ONLY_LAYOUT,
  SUMMARY_LAYOUT,
  REPORT_DISPLAY_NAMES, UNOFFICIAL_REPORT,
} from './reportLayouts';

export const COUNTRY = 'USA';
export const SUBSCRIPTION = 'Standard';
export const COMPANY_ENABLED = true;
export const OFFICIAL_LAYOUT = OFFICIAL_REPORT;
export const INVALID_LAYOUT = UNOFFICIAL_REPORT;
export const DEFAULT_REPORT_TYPE = REPORT_TYPES.STANDARD;
export const DEFAULT_BASIC_LAYOUT = COVER_AND_REPORT_LAYOUT;

export const DEFAULT_LAYOUTS = {
  [COVER_AND_REPORT_LAYOUT]: REPORT_DISPLAY_NAMES[COVER_AND_REPORT_LAYOUT],
  [REPORT_ONLY_LAYOUT]: REPORT_DISPLAY_NAMES[REPORT_ONLY_LAYOUT],
  [SUMMARY_LAYOUT]: REPORT_DISPLAY_NAMES[SUMMARY_LAYOUT],
};



// WEBPACK FOOTER //
// src/constants/defaults.js